import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AdminAdjustCoinsRequest, AdminAdjustCoinsResponse } from '@upme/contracts';
import { api } from '../../app/api-client';
import { coinTransactionsKey } from './api';

// Ручная корректировка баланса (reason MANUAL_ADJUST, SUPERADMIN-only на бэке).
// После успеха инвалидируем ленту, чтобы новая PENDING-строка тут же появилась.
export function useAdjustCoins() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: AdminAdjustCoinsRequest) =>
      api.post('admin/coins/adjust', { json: body }).json<AdminAdjustCoinsResponse>(),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...coinTransactionsKey, 'list'] }),
  });
}
